/* TWM home motion: the home hero only. layout/theme.liquid loads it for
   the index template. Styles live in assets/twm-home-motion.css.

   Desktop (fine pointer, 990 px and up), html.twm-home-fx:
   - the hero curtain (hero zooms and dims as the page slides over it)

   The hero buttons only have the site-wide hover (twm-motion.css).

   Everything else on the page scrolls natively and does not animate in.
   Only translate, scale, opacity and custom properties are written, from
   one requestAnimationFrame per scroll. */
(() => {
  const root = document.documentElement
  if (!root.classList.contains('twm-motion')) return
  const main = document.querySelector('#MainContent')
  if (!main) return

  const clamp = (value, low, high) => Math.min(Math.max(value, low), high)
  const easeOut = (t) => 1 - Math.pow(1 - t, 2)
  const desktop = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)')

  /* ---------- Scroll-linked effects: read in one place, write once a frame ---------- */
  const effects = []
  let queued = false
  const update = () => {
    queued = false
    const y = window.scrollY
    const vh = window.innerHeight
    effects.forEach((effect) => effect(y, vh))
  }
  const queue = () => {
    if (queued) return
    queued = true
    requestAnimationFrame(update)
  }

  /* ---------- Hero curtain ----------
     The first section is sticky (twm-home-motion.css). As the page slides
     over it the picture zooms, the copy lifts away and a black layer
     dims it; once it is fully covered it is hidden from painting. */
  const HERO_COVER = 0.85 // share of the hero height over which the effect plays
  const heroCurtain = () => {
    const section = main.querySelector(':scope > .shopify-section:first-child')
    const hero = section && section.querySelector('.twm-hero')
    if (!hero) return
    // Every slide of the hero slider moves together.
    const medias = Array.from(hero.querySelectorAll('.twm-hero__media'))
    const contents = Array.from(hero.querySelectorAll('.twm-hero__content'))
    let past = false
    // Phones, tablets and a desktop window narrowed below 990 px: no
    // curtain, and nothing left over from it.
    const clear = () => {
      past = false
      section.classList.remove('twm-past')
      medias.forEach((media) => {
        media.style.removeProperty('scale')
        media.style.removeProperty('translate')
      })
      contents.forEach((content) => {
        content.style.removeProperty('translate')
        content.style.removeProperty('opacity')
      })
      hero.style.removeProperty('--twm-hero-dim')
    }
    desktop.addEventListener('change', () => desktop.matches || clear())
    effects.push((y) => {
      if (!desktop.matches) return
      const height = section.offsetHeight
      const covered = y > height + 80
      if (covered !== past) {
        past = covered
        section.classList.toggle('twm-past', covered)
      }
      if (covered) return
      const eased = easeOut(clamp(y / (height * HERO_COVER), 0, 1))
      const scale = (1 + 0.1 * eased).toFixed(4)
      const drop = `0 ${(eased * 48).toFixed(1)}px`
      const lift = `0 ${(-eased * 80).toFixed(1)}px`
      const fade = (1 - clamp(eased * 1.4, 0, 1)).toFixed(3)
      medias.forEach((media) => {
        media.style.scale = scale
        media.style.translate = drop
      })
      contents.forEach((content) => {
        content.style.translate = lift
        content.style.opacity = fade
      })
      hero.style.setProperty('--twm-hero-dim', (eased * 0.6).toFixed(3))
    })
  }

  /* ---------- Start ----------
     html.twm-home-fx follows the media query, so resizing a desktop
     window to phone width drops the sticky hero and its overlapping
     sheet (which would otherwise cover the slider dots). */
  const syncFx = () => {
    root.classList.toggle('twm-home-fx', desktop.matches)
    queue()
  }
  heroCurtain()
  syncFx()
  desktop.addEventListener('change', syncFx)
  window.addEventListener('scroll', queue, { passive: true })
  window.addEventListener('resize', queue)
  update()
})()
